import { render, staticRenderFns } from "./mer.vue?vue&type=template&id=4b644b4d&scoped=true&"
import script from "./mer.vue?vue&type=script&lang=js&"
export * from "./mer.vue?vue&type=script&lang=js&"
import style0 from "./mer.vue?vue&type=style&index=0&id=4b644b4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b644b4d",
  null
  
)

export default component.exports